/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step4_BodyInputs */

const es_landing_step4_body = /** @type {(inputs: Landing_Step4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publica tu anuncio y gestiona tus reservas. Empieza a ganar dinero con tu barco.`)
};

const gl_landing_step4_body = /** @type {(inputs: Landing_Step4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publica o teu anuncio e xestiona as túas reservas. Comeza a gañar diñeiro co teu barco.`)
};

const en_landing_step4_body = /** @type {(inputs: Landing_Step4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish your listing and manage bookings. Start earning from your boat.`)
};

/**
* | output |
* | --- |
* | "Publish your listing and manage bookings. Start earning from your boat." |
*
* @param {Landing_Step4_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_step4_body = /** @type {((inputs?: Landing_Step4_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step4_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_step4_body(inputs)
	if (locale === "en") return en_landing_step4_body(inputs)
	return es_landing_step4_body(inputs)
});